import api from './api';
import { SolicitacaoAbastecimento, ApiResponse } from '../types';

export const solicitacaoService = {
  listar: async (): Promise<SolicitacaoAbastecimento[]> => {
    const response = await api.get<SolicitacaoAbastecimento[]>('/solicitacoes-abastecimento');
    return response.data;
  },

  buscarPorId: async (id: number): Promise<SolicitacaoAbastecimento> => {
    const response = await api.get<SolicitacaoAbastecimento>(`/solicitacoes-abastecimento/${id}`);
    return response.data;
  },

  criar: async (solicitacao: { veiculoId: number; quilometragemAtual: number; litrosSolicitados: number; valorEstimado: number; observacao?: string }): Promise<ApiResponse<SolicitacaoAbastecimento>> => {
    const response = await api.post<ApiResponse<SolicitacaoAbastecimento>>(
      `/solicitacoes-abastecimento`,
      solicitacao
    );
    return response.data;
  },

  aprovar: async (id: number): Promise<ApiResponse<SolicitacaoAbastecimento>> => {
    const response = await api.post<ApiResponse<SolicitacaoAbastecimento>>(
      `/solicitacoes-abastecimento/${id}/aprovar`
    );
    return response.data;
  },

  reprovar: async (id: number, motivo?: string): Promise<ApiResponse<SolicitacaoAbastecimento>> => {
    const response = await api.post<ApiResponse<SolicitacaoAbastecimento>>(
      `/solicitacoes-abastecimento/${id}/reprovar`,
      { motivo }
    );
    return response.data;
  },

  cancelar: async (id: number): Promise<ApiResponse<SolicitacaoAbastecimento>> => {
    const response = await api.post<ApiResponse<SolicitacaoAbastecimento>>(
      `/solicitacoes-abastecimento/${id}/cancelar`
    );
    return response.data;
  },

  listarPorStatus: async (status: string): Promise<SolicitacaoAbastecimento[]> => {
    const response = await api.get<SolicitacaoAbastecimento[]>(`/solicitacoes-abastecimento/status/${status}`);
    return response.data;
  },

  listarPorMotorista: async (motoristaId: number): Promise<SolicitacaoAbastecimento[]> => {
    const response = await api.get<SolicitacaoAbastecimento[]>(`/solicitacoes-abastecimento/motorista/${motoristaId}`);
    return response.data;
  },

  listarPendentes: async (): Promise<SolicitacaoAbastecimento[]> => {
    const response = await api.get<SolicitacaoAbastecimento[]>('/solicitacoes-abastecimento/pendentes');
    return response.data;
  },
};
